import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Input } from 'reactstrap';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons/faSearch';

const SearchInputContainer = styled.div`
  position: relative;

  .search-icon {
    position: absolute;
    top: 50%;
    margin-top: -0.5em;
    left: 0.5em;
  }
  input {
    padding-left: 2em;
  }
`;

function SearchInput({
  containerProps = {},
  iconProps = {},
  onValueChange,
  onChange,
  ...props
}) {
  const handleChange = useCallback((e) => {
    if (onChange) onChange(e);
    if (onValueChange) onValueChange(e.target.value);
  }, [onChange, onValueChange]);
  return (
    <SearchInputContainer {...containerProps}>
      <FontAwesomeIcon icon={faSearch} className="search-icon" {...iconProps} />
      <Input placeholder="Search" {...props} onChange={handleChange} />
    </SearchInputContainer>
  );
}

SearchInput.propTypes = {
  onChange: PropTypes.func,
  onValueChange: PropTypes.func,
  containerProps: PropTypes.object,
  iconProps: PropTypes.object,
};

export default SearchInput;
